import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { UsersService } from 'src/services/users/users.service';
import { DecodedToken, RememberMe, TokenAuth, UserDTO } from "../../../dto/users/users-dto";
import { ModalService } from 'src/services/other/modal.service';
import { AuthServiceService } from "../../../services/authentication/auth-service.service";
import * as jwtDecode from 'jwt-decode';
import { clearLocalStorage, decryptToObject, encryptObject, encryptRememberObject, environment } from 'src/environments/environment';
import { SpinnerService } from 'src/services/other/spinner.service';

@Component({
  selector: 'app-login-sign-up',
  templateUrl: './login-sign-up.component.html',
  styleUrls: ['./login-sign-up.component.css']
})
export class LoginSignUpComponent implements OnInit{
  formLogin: FormGroup;
  isOnSubmit: boolean = false;
  isDisabled: boolean = false;
  hidePassword: boolean = true;

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private loginService: UsersService,
              private modalService: ModalService,
              private spinnerService: SpinnerService
  ) {
    this.formLogin = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      remember: false
    });
  }

  ngOnInit(): void {
      this.spinnerService.hide();

      const isRememberMe = localStorage.getItem('RememberMe');
      if(isRememberMe){
        const user: RememberMe = JSON.parse(decryptToObject(isRememberMe));

        this.formLogin.patchValue({
          username: user.username,
          password: user.password,
          remember: true
        })

      }
  }

  togglePasswordVisibility(): void {
    this.hidePassword = !this.hidePassword;
    const passwordInput = document.getElementById('password');
    if (passwordInput) {
      passwordInput.setAttribute(
        'type',
        this.hidePassword ? 'password' : 'text'
      );
    }
  }

  onSubmit() {
    this.isOnSubmit = true;
    this.isDisabled = true;

    if (this.formLogin.valid) {

      let formValue = this.formLogin.value;

      this.loginService
        .postLoginUser(formValue.username, formValue.password)
        .subscribe({
          next: (data: TokenAuth) => {
            sessionStorage.clear();
            clearLocalStorage();
            data.roles = data.roles.map(role => decryptToObject(role));
            localStorage.setItem('CurrentUser', encryptObject(data));

            if(formValue.remember){
              const remember: RememberMe = {
                username: formValue.username,
                password: formValue.password
              }
              localStorage.setItem('RememberMe', encryptRememberObject(remember))
            }else{
              localStorage.removeItem('RememberMe')
            }
            this.redirectUserToRightPage(data);
          },

          error: (error: any) => {
            this.modalService.open('Loading');
            this.modalService.isError(true, 'UsernameOrPasswordWrong');
            setTimeout(() => {
              this.modalService.hide();
              this.isOnSubmit = false;
              this.isDisabled = false;
            }, 1500);
          },
        });
    }else{
      this.isDisabled = false;
    }
  }

  onSubmitSSO() {
    window.location.href = environment.productionUrl + 'user/' + "sso/login";
  }

  onChangeRemember(event: any) {
    this.formLogin.patchValue({ remember: event.target.checked });
  }

  redirectUserToRightPage(user: TokenAuth) {
    if (user == null) {
      this.router.navigate(['/login']);
    }

    const role = user.roles.find(r =>
      ['SUPER_ADMIN', 'ADMIN', 'PIM', 'DAM', 'CATALOG', 'MEDIA_MANAGER', 'GLRY_VIEW'].includes(r)
    );

    switch (role) {
      case 'SUPER_ADMIN':
      case 'ADMIN':
      case 'PIM':
        this.router.navigate(['/pim']);
        break;

      case 'DAM':
      case 'MEDIA_MANAGER':
        this.router.navigate(['/dam']);
        break;

      case 'CATALOG':
        this.router.navigate(['/catalogues']);
        break;

      case 'GLRY_VIEW':
        this.router.navigate(['/dam/media-library']);
        break;

      default:
        clearLocalStorage();
        this.router.navigate(['/login']);
        break;
    }

  }

}
